import { Module } from '@nestjs/common';
import { winstonConfig } from '../common/logger/winston.config';
import { PrismaModule } from '../prisma/prisma.module';
import { ProductoAtributosController } from './producto-atributos.controller';
import { ProductoAtributosService } from './producto-atributos.service';

@Module({
  imports: [PrismaModule],
  controllers: [ProductoAtributosController],
  providers: [ProductoAtributosService],
  exports: [ProductoAtributosService],
})
export class ProductoAtributosModule {}
